import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  applyParticipantToGtag,
  consumeParticipantIdFromSearch,
  isAnalyticsEnabled,
} from '../utils/analytics';

/**
 * ?shop_id= / ?participant_id= / ?research_shop= を localStorage に取り込み、URL から除去する。
 */
export function useResearchParticipantFromUrl() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.search) return;
    const nextSearch = consumeParticipantIdFromSearch(location.search);
    if (nextSearch === null) return;

    if (isAnalyticsEnabled()) {
      applyParticipantToGtag();
    }

    if (nextSearch === '') {
      navigate({ pathname: location.pathname }, { replace: true });
    } else {
      navigate({ pathname: location.pathname, search: nextSearch }, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);
}
